import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { IClientPortalAuthRequest, IClientPortalAuthResponse } from '../models/auth.model';

@Injectable({ providedIn: 'root' })
export class AccountService {
  private http = inject(HttpClient);
  private resourceUrl = `${environment.apiUrl}/client-portal/authenticate`;

  authenticate(request: IClientPortalAuthRequest): Observable<IClientPortalAuthResponse> {
    return this.http.post<IClientPortalAuthResponse>(this.resourceUrl, request);
  }
}
